import store from '@/store/index';
import EDC from '@/components/games/shared/globals';
import router from '@/router/index';
import { getAvatarNameByPath } from '@/helpers/profile/avatar';

/**
 *
 */
EDC.Games.AvatarSelect.Preview = function (scene, parent, x, y) {
  this.scene = scene;
  this.parent = parent;
  this.background = null;
  this.avatar = null;
  this.selectBtn = null;
  this.chooseNormal = null;
  this.x = x;
  this.y = y;
  this.id = 1;
  this.cursorManager = scene.cursorManager;

  return this;
};
/**
 *
 */
EDC.Games.AvatarSelect.Preview.prototype.create = function () {
  this.background = this.scene.add.sprite(this.x, this.y, 'preview');
  // this.background.setScale(0.5);
  this.selectBtn = this.scene.add.sprite(this.x, this.y + 206, 'select-button');
  this.chooseNormal = this.scene.add.sprite(this.x, this.y + 206, 'choose-text-normal');

  this.parent.add([this.background, this.selectBtn, this.chooseNormal]);

  this.cursorManager.setDefaultDraggableEvents(this.selectBtn);
  this.selectBtn.setInteractive();
  this.selectBtn.on('pointerup', this.onUp, this);

  return this;
};
/**
 *
 */
EDC.Games.AvatarSelect.Preview.prototype.setAvatar = function (avatarItem) {
  this.id = avatarItem.data.id;
  this.avatarPath = avatarItem.data.img;
  this.avatarName = getAvatarNameByPath(this.avatarPath);
  if (!this.avatar) {
    this.avatar = this.scene.add.sprite(this.x, this.y - 40, `avatar-${this.avatarName}`);
    this.avatar.setScale(0.65);
    this.parent.add(this.avatar);
  } else {
    this.avatar.setTexture(`avatar-${this.avatarName}`);
  }
};
/**
 *
 */
EDC.Games.AvatarSelect.Preview.prototype.onUp = function () {
  this.scene.tweens.add({
    targets: this.avatar,
    scaleX: this.avatar.scaleX * 0.8,
    scaleY: this.avatar.scaleY * 0.8,
    duration: 75,
    ease: 'Linear',
    yoyo: true,
  });
  this.cursorManager.resetCursor();
  this.scene.input.enabled = false;

  store.dispatch('children/updateNewProfile', { avatar: this.avatarName });

  const url = new URL(window.location.href);
  if (url.searchParams.get('edit')) {
    store.dispatch('children/updateActiveChild').then(() => {
      router.push({ name: 'profile' });
    });
  } else {
    this.scene.time.delayedCall(500, this.nextScene, [], this);
  }
};

EDC.Games.AvatarSelect.Preview.prototype.nextScene = function () {
  this.scene.scene.start('mainName');
};

export default EDC.Games.AvatarSelect.Preview;
